import slice from './profile.slice'
import { USER_ROLES_ENUMS } from '../Account/account.constants'
import get from 'lodash/get'

export const selectSlice = (state) => state[slice.name]

export const selectUser = (state) => selectSlice(state).user

export const getUserRole = (state) => get(state, 'profile.user.userRole')

export const selectIsAdmin = (state) =>
	getUserRole(state) === USER_ROLES_ENUMS.ADMIN

export const selectIsSales = (state) =>
	getUserRole(state) === USER_ROLES_ENUMS.SALES
